<template>
  <div
    id="user-detail-edit"
  >
    <user-nav
      :userId="userId"
    />
    <back-btn />

    <h2>
      Edit User Details
    </h2>

    <user-detail-form
      :userId="userId"
      show-submit
    />
  </div>
</template>
<script>
import BackBtn from '@/components/BackBtn'
import UserDetailForm from '@/components/UserDetailForm'

import UserNav from '@/components/UserNav'

export default {
  props: {
    'userId': {
      type: [ Number, String ],
      default: undefined
    }
  },

  components: {
    'back-btn': BackBtn,
    'user-detail-form': UserDetailForm,
    'user-nav': UserNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserDetailEdit.vue